<div tabindex="0" class="me-sr-personal-information row" *ngIf="data">
    <div class="me-sr-personal-information--content col-sm-12 col-md-4">
        <div class="me-sr-personal-information--content--header">
            {{data.headline}}
        </div>
        <div class="me-sr-personal-information--content--description" [innerHTML]="data.subHeadline | storyblokRichtext">
        </div>
    </div>
    <div class="me-sr-personal-information--form col-sm-12 col-md-8">
        <div class="me-sr-personal-information--form--checkbox" tabindex="0" role="checkbox" (keyup.enter)="checked = !checked">
            <input id="checkbox" tabindex="-1" type="checkbox" [(ngModel)]="checked">
            <label for="checkbox" class="label">{{data.form[0]['label']}}</label>
        </div>
        <div class="me-sr-personal-information--form--button">
            <button class="btn btn--primary " [ngClass]="checked ? 'btn-active-me' : ''" (click)="next()">
                <ng-container *ngIf="!checked">
                    {{ 'Skip' | translate}}
                </ng-container>
                <ng-container *ngIf="checked">
                    {{ 'Continue' | translate}}
                </ng-container>
            </button>
        </div>
    </div>
</div>